module.exports = __webpack_public_path__ + "static/media/clock.b360bbd4.jpg";